module.exports = __webpack_public_path__ + "static/media/ManageAccounts-BulkTemplate.c5ebea0c.xlsx";